<template>
  <div class="flex flex-wrap justify-between items-center w-full px-4 py-2">
    <h1 style="font-weight: 700;font-size: 1.25rem; line-height: 1.75rem;">Modalidades de Liquidación de Embargos</h1>
    <button v-if="viewInterna === 'list'" type="button" @click="nuevaModalidad()"
            class="flex items-center rounded-md border border-transparent bg-indigo-600 py-2 px-3 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 mr-1">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      Nueva Modalidad
    </button>
    <button v-else type="button" @click="viewInterna = 'list'"
            class="px-4 py-2 text-white bg-green-500 rounded-md hover:bg-green-600 focus:outline-none">
      Volver
    </button>
  </div>

  <div class="mt-4 overflow-x-auto" v-if="viewInterna === 'list'">
    <table class="w-full table-auto">
      <thead>
      <tr class="text-sm font-semibold text-center border-b-2 border-blue-500 uppercase">
        <th class="px-4 py-3">ID</th>
        <th class="px-4 py-3">Nombre</th>
        <th class="px-4 py-3">Tipo de Cálculo</th>
        <th class="px-4 py-3">Porcentaje</th>
        <th class="px-4 py-3">Descripción</th>
        <th class="px-4 py-3">Opciones</th>
      </tr>
      </thead>
      <tbody class="text-sm font-normal text-gray-700 text-center">
        <tr class="py-10 bg-gray-100 hover:bg-gray-200 font-medium" v-for="(modalidad, index) of collectionData" :key="index">
          <td class="px-4 py-4">{{ modalidad.id }}</td>
          <td class="px-4 py-4">{{ modalidad.nombre }}</td>
          <td class="px-4 py-4">{{ nombresTipoCalculo[modalidad.tipo_calculo] || modalidad.tipo_calculo }}</td>
          <td class="px-4 py-4">{{ modalidad.porcentaje != null ? modalidad.porcentaje + ' %' : 'N/A' }}</td>
          <td class="px-4 py-4">{{ modalidad.descripcion }}</td>
          <td class="px-4 py-4">
            <button @click="editarModalidad(modalidad)"
                    class="items-center mx-1 px-2 py-2 text-white bg-indigo-500 rounded-md hover:bg-indigo-600 focus:outline-none">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931z"/>
              </svg>
            </button>
            <button v-if="!modalidad.estado" @click="cambiarEstado(modalidad)"
                    class="items-center mx-1 px-2 py-2 text-white bg-blue-500 rounded-md hover:bg-blue-600 focus:outline-none">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.5 12.75l6 6 9-13.5"/>
              </svg>
            </button>
            <button v-else @click="cambiarEstado(modalidad)"
                    class="items-center mx-1 px-2 py-2 text-white bg-red-500 rounded-md hover:bg-red-600 focus:outline-none">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
              </svg>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div v-else class="bg-white px-4 py-5 sm:p-6">
    <div class="grid grid-cols-6 gap-6">
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="nombre" class="block text-sm font-medium text-gray-700">Nombre <span style="color: red">(*)</span></label>
        <input type="text" id="nombre" v-model="formModalidad.nombre" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="tipo_calculo" class="block text-sm font-medium text-gray-700">Tipo de cálculo <span style="color: red">(*)</span></label>
        <select id="tipo_calculo" v-model="formModalidad.tipo_calculo" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
          <option value="" disabled>Seleccione un tipo de cálculo</option>
          <option v-for="(nombreTipo, claveTipo) in nombresTipoCalculo" :key="claveTipo" :value="claveTipo">{{ nombreTipo }}</option>
        </select>
      </div>
      <div v-if="formModalidad.tipo_calculo === 'porcentaje'" class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="porcentaje" class="block text-sm font-medium text-gray-700">Porcentaje (%) <span style="color: red">(*)</span></label>
        <input type="number" step="0.01" min="0.01" max="100" id="porcentaje" v-model="formModalidad.porcentaje" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="descripcion" class="block text-sm font-medium text-gray-700">Descripción</label>
        <textarea id="descripcion" v-model="formModalidad.descripcion" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"/>
      </div>
    </div>
    <div class="bg-gray-50 px-4 py-3 text-right sm:px-6">
      <button type="button" @click="guardarModalidad()" class="w-full rounded-md sm:w-1/3 lg:w-1/6 border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
        Guardar
      </button>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import Swal from "sweetalert2";
import { useAPIRest, swal, generateTextError } from "@/common/constants";
import { useAuth } from "@/components/auth/store/composables";

export default {
  name: 'ModalidadesLiquidacionCRUD',
  async setup() {
    const authStored = useAuth();
    const authToken = ref(authStored.authToken);
    const viewInterna = ref('list');
    const collectionData = ref([]);
    const formModalidad = ref({ id: null, nombre: '', tipo_calculo: '', porcentaje: '', descripcion: '' });

    const nombresTipoCalculo = {
      porcentaje: 'Porcentaje sobre la base de cálculo',
      quinta_parte_excedente_smmlv: 'Quinta parte que exceda el SMMLV',
      manual: 'Valor manual',
    };

    const listData = async () => await useAPIRest(process.env.VUE_APP_NEST_MODALIDADES_LIQUIDACION_FINDALL, 'GET', authToken.value, undefined, undefined, 'application/json')
      .then(res => {
        collectionData.value = Array.isArray(res) ? res : [];
      });

    await listData();

    const nuevaModalidad = () => {
      formModalidad.value = { id: null, nombre: '', tipo_calculo: '', porcentaje: '', descripcion: '' };
      viewInterna.value = 'form';
    };

    const editarModalidad = (modalidad) => {
      formModalidad.value = {
        id: modalidad.id,
        nombre: modalidad.nombre,
        tipo_calculo: modalidad.tipo_calculo,
        porcentaje: modalidad.porcentaje ?? '',
        descripcion: modalidad.descripcion ?? '',
      };
      viewInterna.value = 'form';
    };

    const guardarModalidad = async () => {
      let error = '';
      if (!formModalidad.value.nombre) error += 'El campo nombre es obligatorio. <br>';
      if (!formModalidad.value.tipo_calculo) error += 'El campo tipo de cálculo es obligatorio. <br>';
      if (formModalidad.value.tipo_calculo === 'porcentaje' && (!formModalidad.value.porcentaje || parseFloat(formModalidad.value.porcentaje) <= 0)) {
        error += 'El porcentaje es obligatorio y debe ser mayor a 0 para el tipo de cálculo porcentaje. <br>';
      }

      if (error !== '') {
        Swal.fire({ title: error, icon: 'error', showCloseButton: true, focusConfirm: false });
        return;
      }

      const dataSave = {
        nombre: formModalidad.value.nombre,
        tipo_calculo: formModalidad.value.tipo_calculo,
        porcentaje: formModalidad.value.tipo_calculo === 'porcentaje' ? parseFloat(formModalidad.value.porcentaje) : null,
        descripcion: formModalidad.value.descripcion || null,
      };

      const resJSON = formModalidad.value.id
        ? await useAPIRest(process.env.VUE_APP_NEST_MODALIDADES_LIQUIDACION_UPDATE.replace(':id', formModalidad.value.id), 'PATCH', authToken.value, dataSave, undefined, 'application/json')
        : await useAPIRest(process.env.VUE_APP_NEST_MODALIDADES_LIQUIDACION_CREATE, 'POST', authToken.value, dataSave, undefined, 'application/json');

      if (resJSON && resJSON.id) {
        await swal.fire('Modalidad guardada con éxito', '', 'success');
        viewInterna.value = 'list';
        listData();
      } else {
        const textoError = generateTextError(resJSON);
        await swal.fire(textoError || 'Error al guardar la modalidad', '', 'error');
      }
    };

    const cambiarEstado = async (modalidad) => {
      const resJSON = await useAPIRest(process.env.VUE_APP_NEST_MODALIDADES_LIQUIDACION_UPDATESTATE.replace(':id', modalidad.id), 'PATCH', authToken.value, {}, undefined, 'application/json');
      if (resJSON && resJSON.id) {
        listData();
      } else {
        const textoError = generateTextError(resJSON);
        await swal.fire(textoError || 'Error al cambiar el estado', '', 'error');
      }
    };

    return {
      viewInterna,
      collectionData,
      formModalidad,
      nombresTipoCalculo,
      listData,
      nuevaModalidad,
      editarModalidad,
      guardarModalidad,
      cambiarEstado,
    };
  },
}
</script>
